import React, { useState } from 'react';
import "./css/Contact.css"
import {questions,social} from "./data.js"
import SingleQuestion from './SingleQuestion.js';
import Next from "./Next.js"
import Footer from "./Footer.js"
import AOS from 'aos';
function Contact() {
    AOS.init();
    const [people,setPeople]=useState(questions)
    return (
        <>
        <main data-aos="fade-in"  
                    data-aos-duration="3000">
          <div className="container3">
          <div className="contact-text">
              <h3>Questions <br/></h3>
            <p><b>Email</b>: bucur.alexandru0106@gmail.com</p>
            <p><b>Phone</b>: +39 327 067 1906</p>
            <div className="socials-contact">
            {social.map((item)=>{
                  const {id,url,icon,name}=item;
                  return <a className="link" href={url} key={id}>{icon}</a>
                

            })}
            </div>
          </div>
            
            
             
            
            <section className="info3">
             {people.map((question)=>{
               return(
                <SingleQuestion key={question.id} {...question}/>
             )})}

            </section>
          </div>
          
        </main>
        
        <Next islast={false}  back="Experience"  href2="/experience" isAbout={true} />
        <Footer/>
        </>
    )
}

export default Contact
